<script setup lang="ts">
const props = defineProps<{
  modalId: string;
  modalTitle: string;
  modalText: string;
  onConfirm: () => void;
  onCancel: () => void;
}>();
</script>

<template>
  <div :id="props.modalId" class="modal fade" tabindex="-1" role="dialog" :data-testid="`modal-${props.modalId}`">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">
            <span>{{ modalTitle }}</span>
          </h3>
        </div>
        <div class="modal-body">
          <span>{{ modalText }}</span>
        </div>
        <div class="modal-footer" :data-testid="`modal-footer-${props.modalId}`">
          <slot name="cancel">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              :data-testid="`modal-cancel-${props.modalId}`"
              @click="onCancel"
            >
              <span>Cancel</span>
            </button>
          </slot>
          <slot name="confirm">
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              :data-testid="`modal-confirm-${props.modalId}`"
              @click="onConfirm"
            >
              <span>Ok</span>
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modal {
  z-index: 999999;
}
</style>
